module.exports = __webpack_public_path__ + "files/c90cdbeb4838b1129a0656b21eacad6c.png";